import * as React from "react";
const SvgLink20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "black",
        viewBox: "0 0 20 20"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M17.779 9.293a5 5 0 0 0-7.071-7.071L10 2.929a4.998 4.998 0 0 0-1.295 4.83l1.89-1.89c.112-.56.385-1.092.819-1.526l.707-.707a3 3 0 0 1 4.243 4.243l-.707.707a2.986 2.986 0 0 1-1.528.82l-1.889 1.889A4.998 4.998 0 0 0 17.071 10l.708-.707ZM2.929 10a4.998 4.998 0 0 1 4.83-1.295l-1.89 1.89a2.986 2.986 0 0 0-1.525.82l-.708.706a3 3 0 1 0 4.243 4.243l.707-.707c.434-.434.707-.968.82-1.527l1.89-1.89A4.998 4.998 0 0 1 10 17.072l-.708.707a5 5 0 0 1-7.07-7.07L2.928 10Zm4.778 3.707 6-6-1.414-1.414-6 6 1.414 1.414Z",
      clipRule: "evenodd"
    })
  );
export default SvgLink20Px;
